import { Link } from '@tanstack/react-router';
import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';

export interface ProvisionWarningsProps {
  /** `warnings` from provisioning or approval; empty when the brand can sell straight away. */
  warnings: readonly string[];
  /** The new store's currency, named in the copy. */
  currency?: string | undefined;
}

/**
 * Things the operator must fix before the new brand can sell. Today that is only a missing USD
 * exchange rate for the store currency, which only the platform can add.
 */
export function ProvisionWarnings({ warnings, currency }: ProvisionWarningsProps) {
  const { t } = useTranslation('organizations');
  if (!warnings.includes('EXCHANGE_RATE_MISSING')) return null;
  return (
    <Alert variant="destructive" role="alert">
      <TriangleAlert aria-hidden />
      <AlertTitle>{t('warnings.exchangeRateMissing.title')}</AlertTitle>
      <AlertDescription>
        <span>
          {currency
            ? t('warnings.exchangeRateMissing.body', { currency })
            : t('warnings.exchangeRateMissing.bodyNoCurrency')}{' '}
          <Link to="/exchange-rates" className="font-medium underline">
            {t('warnings.exchangeRateMissing.link')}
          </Link>
        </span>
      </AlertDescription>
    </Alert>
  );
}
